import store from '@shared/store/index';

import { computed } from "vue";
import { useUserAuth } from '@/Groups/Audioplayer/private/imports/externalStoreData';

const { hasPaidAccount, isLoadingUserData } = useUserAuth();

//---------------------------------------------------------------------
/**
 * Список коинов из портфеля.
 * @type {import('vue').ComputedRef<Object>}
 */
const assets = computed(() => [...store.state.Briefcase.assets].sort((a, b) => a.index - b.index));
//---------------------------------------------------------------------

//---------------------------------------------------------------------
/**
 * Используется ли редактирование
 * @type {import('vue').ComputedRef<Boolean>}
 */
const isEditing = computed(() => store.state.Briefcase.isEditing);
//---------------------------------------------------------------------

//---------------------------------------------------------------------
/**
 * Готов ли виджет к показу
 * @type {import('vue').ComputedRef<Boolean>}
 */
const isReady = computed(() => store.state.Briefcase.isReady);
//---------------------------------------------------------------------

//---------------------------------------------------------------------
/**
 * Открыт ли раздел поиска монет
 * @type {import('vue').ComputedRef<Boolean>}
 */
const isCoinSearchOpened = computed(() => store.state.Briefcase.isCoinSearchOpened);
//---------------------------------------------------------------------

//---------------------------------------------------------------------
/**
 * Промежуточный массив для выбранных из поиска монет для дальнейшей их отправки на сервер
 * @type {import('vue').ComputedRef<Array>}
 */
const pendingAssets = computed(() => store.state.Briefcase.pendingAssets);
//---------------------------------------------------------------------

//---------------------------------------------------------------------
/**
 * Открыт ли раздел поиска монет
 * @type {import('vue').ComputedRef<Boolean>}
 */
const isLoadingAssets = computed(() => store.state.Briefcase.isLoadingAssets);
//---------------------------------------------------------------------

//---------------------------------------------------------------------
/**
 * Криптоактивы портфеля, отсортированные по index
 * @type {import('vue').ComputedRef<Array>}
 */
const coinAssets = computed(() => store.getters['Briefcase/coinAssets']);
//---------------------------------------------------------------------

//---------------------------------------------------------------------
/**
 * RU-акции портфеля, отсортированные по index
 * @type {import('vue').ComputedRef<Array>}
 */
const stockRuAssets = computed(() => store.getters['Briefcase/stockRuAssets']);
//---------------------------------------------------------------------

//---------------------------------------------------------------------
/**
 * Активная вкладка портфеля/поиска ('coin'/'stock_ru') — общая для списка и поиска,
 * переживает пересоздание компонентов при открытии/закрытии поиска.
 * @type {import('vue').ComputedRef<String>}
 */
const activeAssetTab = computed(() => store.state.Briefcase.activeAssetTab);
//---------------------------------------------------------------------

//---------------------------------------------------------------------
//Черновики долей в режиме редактирования: api_id → строка
const draftWeights = computed(() => store.state.Briefcase.draftWeights);
//Итоговые доли, сумма и статус (см. resolveWeights)
const weightState = computed(() => store.getters['Briefcase/weightState']);
//Ошибка сохранения/валидации долей
const weightsError = computed(() => store.state.Briefcase.weightsError);
//Показывается ли портфель в рейтинге комьюнити
const isPublic = computed(() => store.state.Briefcase.isPublic);
//Идёт ли сохранение флага публичности
const isSavingVisibility = computed(() => store.state.Briefcase.isSavingVisibility);
//Загружена ли настройка публичности портфеля с сервера
const isVisibilityLoaded = computed(() => store.state.Briefcase.isVisibilityLoaded);
//Ошибка загрузки/сохранения публичности портфеля
const visibilityError = computed(() => store.state.Briefcase.visibilityError);
//---------------------------------------------------------------------

/**
 * Composable-функция для работы с коинами из портфеля
 * Предоставляет реактивные свойства состояния портфеля.
 * 
 * @example
 * const { assets } = useBriefcaseState();
 * 
 * @returns {{
 *   assets: import('vue').ComputedRef<Array>, // Список коинов из портфеля
 *   isCoinSearchOpened: import('vue').ComputedRef<Boolean>, // Открыт ли раздел поиска монет
 *   
 * }}
 */


export function useBriefcaseState() {
  return {
    assets,
    coinAssets,
    stockRuAssets,
    activeAssetTab,
    isCoinSearchOpened,
    isLoadingAssets,
    isEditing,
    isReady,
    pendingAssets,
    draftWeights,
    weightState,
    weightsError,
    isPublic,
    isSavingVisibility,
    isVisibilityLoaded,
    visibilityError
  };
}